export enum TermosEnum {
  GLOBAL_ACCOUNT_AGREEMENT_PT_BR = 'global-account-agreement-pt-BR.pdf',
}
